import React from 'react';
import Link from 'next/link';

// import ListYellowBulletIcon from "../../../Asset/Icons/ListYellowDotIcon.svg";

const SearchBox = ({
  inputValue,
  filteredCollegeData,
  handleLinkClick,
  filteredExamData,
  filteredNewsData,
  filteredCourseData: courseData,
}: any) => {
  return (
    <>
      {inputValue.length > 0 && inputValue.length < 3 && (
        <p className="text-start mb-2 text-gray-600 font-medium">Type 3 or more characters for search results...</p>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-2">
        {/* Popular Colleges */}
        <div className="border-gray-300 md:border-r-[1.5px] pr-4">
          <h2 className="text-primary font-semibold text-base lg:text-xl font-inter">Popular Colleges</h2>
          <div className="font-inter flex flex-col gap-1.5 mt-3 text-xs lg:text-sm leading-tight tracking-tighter">
            {filteredCollegeData?.slice(0, 8).map((college: any) => {
              const isOnlineCollege = college?.is_online_college;
              const navbar =
                college?.college_navbars?.[0]?.title?.replace(/\s+/g, '-')?.toLowerCase() ?? 'college-info';
              const collegeUrl = isOnlineCollege
                ? `/colleges/${college?.college_url}`
                : `/colleges/${college?.college_url}/${navbar}`;
              return (
                <div key={college?.id} className="flex items-start gap-x-1">
                  <Link href={collegeUrl} className="text-primary-gray hover:text-primary" onClick={handleLinkClick}>
                    <h2 className="line-clamp-1 pr-2">{college?.abbreviation ?? college?.college_name}</h2>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
        
          {/* Top Exams */}
          <div className="border-gray-300 md:border-r-[1.5px] px-2 md:px-4">
            <h2 className="text-primary font-semibold text-base lg:text-xl font-inter">Top Exams</h2>
            <div className="font-inter flex flex-col gap-1.5 mt-3 text-xs lg:text-sm leading-tight tracking-tighter">
              {filteredExamData?.slice(0, 8).map((exam: any) => {
                const navbar = exam?.exam_navbars?.[0]?.title?.replace(/\s+/g, '-')?.toLowerCase() ?? 'exam-info';
                return (
                  <div key={exam?.id} className="flex items-start gap-x-1">
                    <Link
                      href={`/exams/${exam?.exam_url}/${navbar}`}
                      className="text-primary-gray hover:text-primary"
                      onClick={handleLinkClick}
                    >
                      <h2 className="line-clamp-1 pr-2">{exam?.abbreviation ?? exam?.exam_name}</h2>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Top Courses */}
           <div className=" md:px-3">
            <h2 className="text-primary font-semibold text-base lg:text-xl font-inter">Top Courses</h2>
            <div className="font-inter flex flex-col gap-1.5 mt-3 text-xs lg:text-sm leading-tight tracking-tighter">
              {courseData?.slice(0, 8).map((course: any) => {
                const navbar = course?.course_navbars?.[0]?.title?.replace(/\s+/g, '-')?.toLowerCase() ?? 'course-info';
                return (
                  <div key={course?.id} className="flex items-start gap-x-1">
                    <Link
                      href={`/courses/${course?.course_url}/${navbar}`}
                      className="text-primary-gray hover:text-primary"
                      onClick={handleLinkClick}
                    >
                      <h2 className="line-clamp-1 pr-2">{course?.abbreviation ?? course?.course_name}</h2>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
      </div>

      {/* Trending News */}
      {filteredNewsData?.length > 0 && (
        <div className="border-t-[1.5px] border-gray-300 mt-5 pt-4">
          <h2 className="text-primary font-semibold text-base lg:text-xl font-inter">Trending News & Articles</h2>
          <div className="font-inter flex flex-col gap-1.5 mt-3 text-xs lg:text-sm leading-tight tracking-tighter">
            {filteredNewsData?.slice(0, 5).map((news: any) => (
              <div key={news?.id} className="flex items-start gap-x-1">
                {/* <span className="w-3 mt-1 inline-block">
                  <ListYellowBulletIcon />
                </span> */}
                <h2 className="line-clamp-2">
                  <Link
                    href={`/news/${news.url}`}
                    className="text-primary-gray hover:text-primary"
                    onClick={handleLinkClick}
                  >
                    {news?.name}
                  </Link>
                </h2>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SearchBox;
